import { Chip } from "@mui/material";

export function QuickFilter({ label }: { label: string; source: string; defaultValue: any }) {
  return <Chip sx={{ marginBottom: 1 }} label={label} />;
}
